import { useEffect } from "react";
import { exchangeSession } from "../lib/api";

// Module-level flag prevents React strict mode double-execution
let isProcessing = false;

export default function AuthCallback() {
  useEffect(() => {
    if (isProcessing) return;
    isProcessing = true;

    const hash = window.location.hash || "";
    const params = new URLSearchParams(hash.replace("#", ""));
    let sessionId = params.get("session_id");
    if (!sessionId) {
      const searchParams = new URLSearchParams(window.location.search);
      sessionId = searchParams.get("session_id");
    }

    if (!sessionId) {
      isProcessing = false;
      window.location.href = "/auth";
      return;
    }

    (async () => {
      try {
        const res = await exchangeSession(sessionId);
        const userData = res.data;
        // Full page redirect — ensures cookie is recognized on next page load
        if (!userData.role) {
          window.location.href = "/select-role";
        } else if (userData.role === "landlord") {
          window.location.href = "/landlord-dashboard";
        } else if (userData.role === "admin") {
          window.location.href = "/admin";
        } else {
          window.location.href = "/dashboard";
        }
      } catch (err) {
        console.error("Auth callback error:", err);
        isProcessing = false;
        window.location.href = "/auth";
      }
    })();

    return () => { /* keep isProcessing true to prevent re-runs */ };
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "#faf8f3" }}>
      <div className="text-center">
        <div className="w-10 h-10 border-4 border-[#1a6b3c] border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="text-[#0d0d0d] font-medium">Signing you in...</p>
      </div>
    </div>
  );
}
